import textbox from './textbox';
import group from './group';
import drawing from './drawing';
import rect from './rect';
import image from './image';
import inpaint from './inpaint';

export default {
  textbox,
  group,
  drawing,
  rect,
  image,
  inpaint,
};
